import {
  getHospitalSettingsSchemas,
  updateHospitalSettingsSchemas,
  type UpdateHospitalSettingsBody,
} from "@opendialysis/procare-api-schemas";

import { apiClient } from "../../../lib/apiClient";
import { API } from "../../../constants/apiRoutes";

/** Singular /hospital — the plural CRUD went away with the single-hospital change. */
export async function getHospital() {
  const { data } = await apiClient.get(API.hospital);
  return getHospitalSettingsSchemas.response[200].parse(data);
}

export async function updateHospital(input: UpdateHospitalSettingsBody) {
  const { data } = await apiClient.put(API.hospital, input);
  return updateHospitalSettingsSchemas.response[200].parse(data);
}
